import { useState, useEffect } from 'react';
import { useLocation, Location } from 'react-router-dom';

function usePreviousRoute(): Location | null {
  const [previousLocation, setPreviousLocation] = useState<Location | null>(null);
  const location = useLocation();

  useEffect(() => {
    setPreviousLocation(location);
  }, [location]);

  return previousLocation;
}

export default usePreviousRoute;
